<template>
  <div id="app">
    <Header @logout="handleLogout" class="app-header"/>
    <div class="main-content">
      <div class="content">
        <router-view/>
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue'
import {useRouter} from 'vue-router'
import Header from './components/layout/Header.vue'
import Footer from "@/components/layout/Footer.vue";

const router = useRouter()
const loggedIn = ref(false)

function handleLogout() {
  loggedIn.value = false
  localStorage.removeItem('loggedIn')
  router.push('/login')
}

</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css');

html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'Raleway', 'Tahoma', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.app-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #f8f9fa;
}

.main-content {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 4rem);
  overflow: hidden;
}

.content {
  flex: 1;
  overflow-y: auto;
  background-color: rgb(243, 243, 243);
}

</style>
